var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldLocationSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.51c-1.36 0-2.72-.52-3.78-1.54-.36-.34-.72-.72-1.08-1.11l12.9-12.9c.25.54.44 1.11.58 1.74 1.17 5.16-1.99 9.52-4.84 12.28A5.436 5.436 0 0 1 12 22.51zM20.679 2.229l-18.45 18.46c-.3.3-.3.79 0 1.09a.758.758 0 0 0 1.08-.01l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 7.16c1.31 0 2.43.8 2.91 1.94l3.98-3.98C17.119 2.98 14.439 2 11.999 2c-1.77 0-3.66.52-5.24 1.61-1.58 1.1-2.86 2.77-3.38 5.08-.84 3.67.52 6.95 2.41 9.52l5-5a3.144 3.144 0 0 1 1.21-6.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLocationSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-location-slash.e303bd90910bf64496462ed160e31ab1.svg";
export { ForwardRef as ReactComponent };